// import styles bundle
import Swiper from 'swiper/bundle';
import "../css/style.scss";

import Swip from "./modules/swiper";
import Pristine from 'pristinejs';
import ajax from '@fdaciuk/ajax';


const app = {

  teamSwiper: () => {
    var swiper = null; // Variable to store the Swiper instance
  
    const initializeSwiper = () => {
      if (document.querySelector(".team__list")) {
        swiper = new Swiper('.team__list', {
          spaceBetween: 10,
          slidesPerView: 3,
          centeredSlides: true,
          speed: 500,
          observer: true,
          loop: true,
          observeParents: true,
          navigation: {
            nextEl: ".team-next",
            prevEl: ".team-prev",
          },
          breakpoints: {
            624: {
              slidesPerView: 4,
            },
            1124: {
              slidesPerView: 6,
              spaceBetween: 31,
              loop: false,
              centeredSlides: false
            }
          }
        });
      }
    };
  
    initializeSwiper(); 

    window.addEventListener('resize', () => {
      if (swiper !== null) {
        swiper.destroy(); 
      }
      initializeSwiper(); 
    });
  },

  expertsSwiper: () => {
    var slider = null; 
    var thumbs = null; 
  
    const initializeSwiper = () => {
      if (document.querySelector(".experts__swiper")) {
        slider = new Swiper('.experts__swiper', {
          slidesPerView: 1,
          centeredSlides: true,
          loop: true,
          loopedSlides: 5,
          navigation: {
            nextEl: '.experts-next',
            prevEl: '.experts-prev',
          },
          breakpoints: {
            1024: {
  
            }
          },
        });
  
        thumbs = new Swiper('.experts__thumbs', {
          spaceBetween: 10,
          slidesPerView: 3,
          centeredSlides: true,
          loopedSlides: 5,
          loop: true,
          breakpoints: {
            624: {
              slidesPerView: 4,
            },
            1024: {
              slidesPerView: 'auto',
              direction: 'vertical',
              spaceBetween: 8,
              centeredSlides: true,
              slideToClickedSlide: true
            }
          }
        });
  
        slider.controller.control = thumbs;
        thumbs.controller.control = slider;
      }
    };
  

    initializeSwiper();
  
 
    window.addEventListener('resize', () => {
      if (slider !== null) {
        slider.destroy(); 
        thumbs.destroy(); 
      }
      initializeSwiper(); 
    });
  },

  getValidationConfig: () => {

  Pristine.addValidator(
      'equals',
      function (val, otherFieldSelector) {
          var other = document.querySelector(otherFieldSelector);
          return other && ((!val && !other.value) || other.value === val);
      },
      'Fields do not match',
      1,
      true
  );

  let config = {
        classTo: 'form__input__group',
        errorClass: 'form__input__group--error',
        successClass: 'form__input__group--success',
      };

      return config;

  },

  forms: () => {

    // Get validation config
    let config 				= app.getValidationConfig();

    // Get forms to validate
    let contactForms			= document.querySelectorAll('.contact-form__form');

    	// Newsletter Form Validation
    	if ( contactForms	) {
    	[].forEach.call(contactForms, contactForm => {
    			let contactFormValidator = new Pristine(contactForm, config, true);
    			contactForm.addEventListener("submit", function (e) {
    				if ( !contactFormValidator.validate() ) {
    					e.preventDefault();
    				}
    			});

    		});

    	}

	},

  text: () => {

    const allTextElements = document.querySelectorAll('.p-animation p'); // Replace 'p' with the selector for the text elements you want to highlight

    if (allTextElements ) {
      const windowHeight = window.innerHeight;
      const middle = windowHeight / 2;

      allTextElements.forEach((element) => {
        const elementTop = element.getBoundingClientRect().top;
        const elementHeight = element.getBoundingClientRect().height;

        if (elementTop + (elementHeight / 2) >= middle && elementTop <= middle + (elementHeight / 2)) {
          element.classList.add("main-p");
        } else {
          element.classList.remove("main-p");
        }
      });
    }


  },

  showMobileMenu: () => {

    let mobileMenu = document.querySelector('.menu-wrapper');
    let hamburger = document.querySelector('.hamburger');


    if (hamburger) {

        hamburger.addEventListener('click', () => {
          mobileMenu.classList.toggle('active');
          hamburger.classList.toggle('active');
          document.body.classList.toggle('body-no-scroll');
        });

      }
  },

  langsMenu: () => {

    let menus = document.querySelectorAll('.langs-menu');

    if (menus) {

      [].forEach.call(menus, menu => {

        const mainBtn = menu.querySelector('.langs-menu__btn');
        const list = menu.querySelector('.langs-menu__sub');
        mainBtn.addEventListener('click', (e) => {
          e.preventDefault();
          menu.classList.toggle('active');
        });

      });

    }
  },

  mobileAccords: () => {

    const mediaQuery = window.matchMedia('(max-width: 850px)');

    function mobileAccords() {

      var acc = document.getElementsByClassName("has-submenu-btn");
      var i;

      for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function(e) {
          e.preventDefault();
          this.classList.toggle("active");
          var panel = this.nextElementSibling;
          if (panel.classList.contains("list-visible")) {
            panel.classList.remove("list-visible");
          } else {
            panel.classList.add("list-visible");
          }
        });
      }
    }

    if (mediaQuery.matches) {
      mobileAccords();
    }

    mediaQuery.addEventListener('change', (event) => {
      if (event.matches) {
        mobileAccords();
      }
    });


  },

  mobileMenu: () => {

    const mediaQuery = window.matchMedia('(max-width: 850px)');

    function mobileMenu() {

      var acc = document.querySelectorAll(".header__menu li a");
      let mobileMenu = document.querySelector('.menu-wrapper');
      let hamburger = document.querySelector('.hamburger');

      var i;
      console.log(acc);
      for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function(e) {
          mobileMenu.classList.toggle('active');
          hamburger.classList.toggle('active');
          document.body.classList.toggle('body-no-scroll');
        });
      }
    }

    if (mediaQuery.matches) {
      mobileMenu();
    }

    mediaQuery.addEventListener('change', (event) => {
      if (event.matches) {
        mobileMenu();
      }
    });


  },

  contactForm: () => {

    let config 				= app.getValidationConfig();
    let forms 		= document.querySelectorAll('.contact-form');

    if ( forms ) {

      [].forEach.call(forms, form => {

        let submitBtn   = form.querySelector('.btn');
        let contactForm = form.querySelector('.contact-form__form');
        let msg         = form.querySelector('.cf-message');
        let formValidator = new Pristine(contactForm, config, true);

          submitBtn.addEventListener('click', () => {
            if ( formValidator.validate()  ) {
            event.preventDefault();
            var formData = new FormData(contactForm);

            formData.append('action', contactForm.getAttribute('data-action'));

            let request = ajax({
              method: 'POST',
              headers: {
                  'content-type': false
              },
              url: wp.ajax,
              data: formData
            })
            request.then(function(response) {
                contactForm.reset();
                formValidator.reset();
                let inputFields = contactForm.querySelectorAll('input, textarea');
                [].forEach.call(inputFields, field => {
                    field.value = '';
                });
              	msg.textContent = response.msg;
            });
           }

          }, false);

        });
      }
  },

  onScroll: () => {
    app.text();
  },

  onResize: () => {
    app.text();
    app.teamSwiper();
  },

  init: () => {
    app.teamSwiper();
    app.expertsSwiper();
    app.forms();
    app.showMobileMenu();
    app.langsMenu();
    app.mobileAccords();
    app.contactForm();
    app.mobileMenu();
  }
};

const mainSw = new Swip()

document.addEventListener("DOMContentLoaded", () => {
	app.init();
  window.addEventListener("scroll", app.onScroll);
  window.dispatchEvent(new Event("scroll"));

  window.addEventListener("resize", app.onResize);
  window.dispatchEvent(new Event("resize"))
});
